export const convertBytesToDisplayText = (fileSizeInBytes: number, fractionDigits: number = 2) => {
    const KB = 1024;
    const MB = KB * 1024;
    const GB = MB * 1024;

    if (fileSizeInBytes < KB) {
        return fileSizeInBytes + " bytes";
    } else if (fileSizeInBytes < MB) {
        return (fileSizeInBytes / KB).toFixed(fractionDigits) + " KB";
    } else if (fileSizeInBytes < GB) {
        return (fileSizeInBytes / MB).toFixed(fractionDigits) + " MB";
    } else {
        return (fileSizeInBytes / GB).toFixed(fractionDigits) + " GB";
    }
};
